import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';
import { colorShade } from 'utils';

const template = styled.tr`
  ${({ theme, displayState }) => css`
    border-bottom: 1px solid #E7EBEB;
    height: 60px;

    cursor: ${displayState?.clickable ? 'pointer' : ''};
    &:hover {
      background: ${displayState?.clickable ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : ''};
    }
  `}
`;

export default Wrapper(template);